export default __webpack_public_path__ + "static/media/room-service.98e40274.svg";